import axiosInstance from "../utils/axios";

const EXTEND_URL = "/customers/users/v1";

function customerUserApi(email: string, includeLoginMethods?: boolean) {
  const includeLoginMethodsParam =
    includeLoginMethods != null
      ? "&includeLoginMethods=" + !!includeLoginMethods
      : "";

  const encodedEmail = encodeURIComponent(email);

  return axiosInstance
    .get(`${EXTEND_URL}?email=${encodedEmail}${includeLoginMethodsParam}`);
}

function createMerchantCustomerApi(data: any) {
  return axiosInstance.post(`/customers/v1`, JSON.stringify(data));
}

export { customerUserApi, createMerchantCustomerApi };